// This file contains the settings of the appConfig that needs to be overridden when the application is run in development.

export const appConfig = {
    // Test clientId and apiScope
    //frontendMsalClientId: '2b469442-72ef-41c9-a00b-6571779b5c37',
    //frontendMsalApiScope: 'api://a7102ade-c5f0-45ec-9725-379c86b733ad/Tenant.Read',

    // Production clientId and apiScope
    //frontendMsalClientId: 'e4e908d5-b920-44be-b1b7-acd33ce08166',
    //frontendMsalApiScope: 'https://admin.cybergate.cybertwice.com/api/Tenant.Read',

    // CyberGate Management Portal front-end Local clientId and apiScope
    frontendMsalClientId: '2d321975-3660-4e79-8b3f-71531da02a7a',
    frontendMsalApiScope: 'https://admin.teresacare.nl/api/Tenant.Read',
};
